export const routingPaths = {
  index: "/",
  documents: "/documents",
  document: (documentId: string) => `/documents/${documentId}`,
  documentPage: (documentId: string, pageId: string) =>
    `/documents/${documentId}/${pageId}`,
  settings: "/settings",
  help: "/help",
};
